// TODO we will likely want to use formatNumberAsString instead of this function. Using commas will not always be correct depending on customer location.
// NOTE: Doesn't work with numbers that have three or more numbers after the decimal place.
export function numberWithCommas(num: number) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function formatNumberAsString(num: number): string {
    return num.toLocaleString();
}

/**
 * util used to convert a nullable decimal into a fixed 2 hundreds places number (ie 2.2342 => 2.23)
 * @param {string | number} value
 * @returns number converted to a hundreds fixed decimal
 */
export function formatDecimalToFixedNumber(
    value?: string | number | null,
    fixedValue = 2
) {
    if (!value || isNaN(Number(value))) return null;
    return Number(value).toFixed(fixedValue);
}

/**
 * util used to convert a nullable decimal into a fixed 2 hundreds places number percent (ie 2.2342 => 2.23%)
 * @param {string | number} value
 * @returns number converted to a hundreds fixed decimal
 */
export function formatDecimalToFixedPercent(
    value?: string | number | null,
    fixedValue = 2
) {
    if (!value || isNaN(Number(value))) return null;
    return `${Number(value).toFixed(fixedValue)}%`;
}
